import React from "react";
import ReactDom from "react-dom";

import YouTubeVideo from "./YouTubeVideoApp.jsx";

export default function renderYoutubeVideo() {
  document.querySelectorAll(".js-youtube-video-mount").forEach((mount) => {
    const dataModel = JSON.parse(mount.dataset.model);
    const dataAutoplay = mount.dataset.autoplay;

    ReactDom.render(<YouTubeVideo {...dataModel} autoplay={dataAutoplay} />, mount);
  });
}
